export default "__VITE_ASSET__DdNbMh9q__"